// src/pages/Schedule/builders/buildDispatchRows.js
export function buildDispatchRows({
  rows,
  assignmentsByRole,
  blockedSlots,
  publishedShiftsByRole,
  handlers,
}) {
  return rows.map((row) => ({
    ...row,
    assignment:
      row.assignment ??
      assignmentsByRole?.[row.roleKey] ??
      null,
    assignments:
      row.assignments ??
      (assignmentsByRole?.[row.roleKey]
        ? [assignmentsByRole[row.roleKey]]
        : []),
    blocked:
      row.blocked ??
      !!blockedSlots?.[row.roleKey],
    publishedShifts:
      row.publishedShifts ??
      publishedShiftsByRole?.[row.roleKey] ??
      [],
    ...handlers(row.roleKey),
  }));
}